<template>
  <router-view/>
</template>

<script>
export default {
  title: "视频监控",
  name:'videoSurveillance'
}
</script>